// Permission, server and network failures stop the person's work, so they get a dialog they must read rather than a toast that
// fades. Every other toast is untouched. Imported once from App.js; the 500+ toast.error(...) call sites do not change.
import { toast } from "sonner";
import { messageKind } from "@/lib/errors";
import { showNotice } from "@/lib/dialogs";

const SHAPES = {
  permission: { kind: "permission", title: "You don't have permission", footnote: "Nothing was changed. Ask your administrator for access to this action." },
  server: { kind: "error", title: "That didn't work", footnote: "Check the record before trying again, in case part of it was saved." },
  network: { kind: "error", title: "Can't reach the server", footnote: "Nothing was sent. Check your connection, then try again." },
};

const original = toast.error.bind(toast);
let last = { message: "", at: 0 };

toast.error = (message, data) => {
  const shape = typeof message === "string" ? SHAPES[messageKind(message)] : null;
  if (!shape) return original(message, data);
  if (message === last.message && Date.now() - last.at < 1500) return undefined;   // several calls for one failure show one dialog
  last = { message, at: Date.now() };
  showNotice({ ...shape, description: message });
  return undefined;
};
